import * as React from "react";
import { findDOMNode } from "react-dom";

import { DomElementHack } from "./Commons/DOM/DomElementHack";
import { nullElement } from "./TypingUtils";

interface InjectDataPropsProps {
    children: React.ReactElement;
    dataAttributes: Record<string, string | undefined>;
}

export function InjectDataProps(props: InjectDataPropsProps): JSX.Element {
    const componentElement = React.useRef<DomElementHack>(nullElement);
    React.useEffect(() => {
        const element = findDOMNode(componentElement.current);
        if (element != undefined && element instanceof Element) {
            for (const [name, value] of Object.entries(props.dataAttributes)) {
                if (typeof value === "string") {
                    element.setAttribute(name, value);
                } else {
                    element.removeAttribute(name);
                }
            }
        }
    }, Object.values(props.dataAttributes));

    return <DomElementHack ref={componentElement}>{props.children}</DomElementHack>;
}
